enum EnergyUnitType {
    kWh,
    m3,
    GJ,
    euro,
    co2,
    percentage,
}

export default EnergyUnitType;